<template>
  <div>
    <div class="match-area">
      <div class="info-container section">
        <h3>Game #{{game.gameCode}} Info</h3>
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="infoRow">
              <span class="infoLabel">Game Code:</span>{{game.gameCode}}
            </div>
            <div class="infoRow">
              <span class="infoLabel">Your name:</span> {{ player.username }}
            </div>
            <div v-if="game.playerIDs.length" class="infoRow">
              <span class="infoLabel">Current number of players: </span>[{{
                game.playerIDs.length
              }}/{{ game.maxPlayers }}]
            </div>
            <div class="infoRow">
              <span class="infoLabel">Minimum number of players:</span>
              {{ game.minPlayers }}
            </div>

          </div>
          <div class="col-12 col-sm-6">
            <div class="infoRow">
              <span class="infoLabel">Number of questions: </span
              >{{ game.qnum }}
            </div>
            <div v-if="game.playerIDs.length" class="infoRow">
              <span class="infoLabel">Game owner: </span>{{ adminName }}
            </div>
            <div class="infoRow">
              <span class="infoLabel">Timer:</span>{{ num00(game.hour) }}:{{
                num00(game.minute)
              }}:{{ num00(game.second) }}
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12">
            <div v-if="game.playerIDs.length"  class="infoRow"><b>Players: </b><span v-html="ingamePlayers"></span></div>
          </div>
        </div>
      </div>
      <div class="setting-area section" v-if="game.playerIDs[0] === player.id">
        <h3>Game Settings</h3>
        <div class="form-row">
          <div class="col-12 col-md-6 mb-3">
            <label for="minPlayers"
              >Minimum number of players: {{ minPlayers }}</label
            >
            <input
              type="range"
              class="custom-range"
              min="2"
              id="minPlayers"
              v-model="minPlayers"
              v-bind:max="maxPlayers"
              v-on:change="changeGameSetting()"
            />
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label for="maxPlayers"
              >Maximum number of players: {{ maxPlayers }}</label
            >
            <input
              type="range"
              class="custom-range"
              max="20"
              id="maxPlayers"
              v-model="maxPlayers"
              v-bind:min="minPlayers"
              v-on:change="changeGameSetting()"
            />
          </div>

          <div class="col-12 col-md-4 mb-3">
            <label for="maxPlayers">Hour: {{ hour }}</label>
            <input
              type="range"
              class="custom-range"
              min="0"
              max="12"
              step="1"
              id="hour"
              v-model="hour"
              v-on:change="changeGameSetting()"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label for="maxPlayers">Minute: {{ minute }}</label>
            <input
              type="range"
              class="custom-range"
              min="1"
              max="59"
              step="1"
              id="minute"
              v-model="minute"
              v-on:change="changeGameSetting()"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label for="maxPlayers">Second: {{ second }}</label>
            <input
              type="range"
              class="custom-range"
              min="0"
              max="59"
              step="1"
              id="second"
              v-model="second"
              v-on:change="changeGameSetting()"
            />
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label for="maxPlayers">Number of Questions: {{ qnum }}</label>
            <input
              type="range"
              class="custom-range"
              min="1"
              max="100"
              step="1"
              id="qnum"
              v-model="qnum"
              v-on:change="changeGameSetting()"
            />
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label for="maxPlayers">Game Visibility</label>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="public"
                v-model="public"
                v-on:change="changeGameSetting()"
              />
              <label class="custom-control-label" for="public">{{
                public ? "Public" : "Private"
              }}</label>
            </div>
            <small id="emailHelp" class="form-text text-dark"
              >If the game is private, players can only join via the game
              code.</small
            >
          </div>
        </div>
      </div>
      <div class="section">
        <div
          class="matchfield-button-container mt-3 px-3"
          v-if="game.state === 0"
        >
          <div class="row">
            <button
              v-bind:disabled="player.ready"
              v-bind:class="{ pulse: !player.ready, disabled: player.ready }"
              class="btn btn-success mr-3 btn-mobile-block animated infinite slower col-12 col-md-3"
              v-on:click="readyPlayer()"
            >
              <i class="fas fa-check mr-3"></i>I am ready
            </button>

            <button
              v-bind:disabled="player.username !== adminName || !countdown"
              class="btn btn-primary mr-3 btn-mobile-block col-12 col-md-4"
              v-bind:class="{ disabled: player.username !== adminName || !countdown}"
              v-on:click="startGame()"
            >
              <i class="fas fa-play mr-3"></i>{{startBtnTxt}} <span v-if="countdown">({{countdown}}s)</span>
            </button>

            <button
              class="btn btn-secondary btn-mobile-block col-12 col-md-3"
              @click="leaveGame()"
            >
              <i class="fas fa-door-open mr-3"></i>Leaving the game
            </button>
          </div>
        </div>
        <div class="row mt-3">
          <p class="small mt-2" v-if="player.ready">
            The game starts automatically as soon as more than
            {{ game.minPlayers }} players are online and all players are ready.
          </p>
        </div>
      </div>
    </div>
    <div
      class="alert mt-2 fixed-bottom mx-5"
      v-on:click="hideMessage()"
      v-bind:class="{
        'alert-info': message.state === 'info',
        'alert-danger': message.state == 'danger',
        'alert-success': message.state == 'success',
        'alert-warning': message.state == 'warning',
      }"
      v-if="message.show"
      v-html="message.msg"
    ></div>
  </div>
</template>

<script>
import GameService from "@/services/GameService.js";
import PlayerService from "@/services/PlayerService.js";

export default {
  name: "WaitingMatch",
  data() {
    return {
      adminName: "",
      game: {
        playerIDs: [],
      },
      player: {},
      ingamePlayers: [],
      minPlayers: 2,
      maxPlayers: 4,
      qnum: 10,
      hour: 0,
      minute: 0,
      second: 10,
      public: true,
      message: {
        show: false,
        msg: "",
        state: "info",
      },
      countdown:null,
    };
  },
  components: {},
  computed:{
    startBtnTxt(){
      return this.player.username !== this.adminName ? "Wait for the owner to start the game" : "Start the game";
    }
  },
  async created() {
    // get gameCode from store (set in Enter or Create Game)
    const gameCode = this.$route.params.gameCode;

    this.player = this.$store.state.player;

    // search for game
    GameService.getGame(gameCode)
      .then(async (game) => {
        // redirect user to enter area if no player is set
        if (!this.player) {
          this.$router.push({
            path: "/game/enter",
          });
          return;
        }

        // if game is full
        if (
          !GameService.playerIsInGame(this.player, game) &&
          game.playerIDs.length >= game.maxPlayers
        ) {
          this.$router.push({
            name: "start",
            params: {
              error: "The maximum number of players has already been reached.",
            },
          });
          return;
        }

        // if game state not waiting
        if (game.state !== 0) {
          this.$router.push({
            name: "start",
            params: {
              error: "The game has already started.",
            },
          });
          return;
        }

        // add player if not in game
        if (!GameService.playerIsInGame(this.player, game)) {
          game = await GameService.addPlayerToGame(
            game.gameCode,
            this.player.id
          );

          // add socket event for user joining
          this.$socket.emit("playerJoinGame", {
            gameCode: game.gameCode,
            player: this.player,
          });

          // message for other players
          this.$socket.emit("waitingMatchMessage", {
            gameCode: game.gameCode,
            player: this.player,
            message: `<b>${this.player.username}</b> entered the game.`,
            state: "info",
          });
        }

        // set game global for this component
        this.game = game;

        // get players
        this.getPlayers();

        // get admin name
        this.getAdminName();

        // set setting vars
        this.minPlayers = this.game.minPlayers;
        this.maxPlayers = this.game.maxPlayers;
        this.fieldsize = this.game.fieldsize;
        this.public = this.game.public;
        this.qnum = this.game.qnum;
        this.hour = this.game.hour;
        this.minute = this.game.minute;
        this.second = this.game.second;

        this.loaded = true;

        return;
      })
      .catch((err) => {
        // no game found => push to home
        this.$router.push({
          name: "start",
          params: {
            error: "The requested game does not exist.",
          },
        });
        return;
      });
  },
  sockets: {
    updateGameVars: function (data) {
      // only when gameCode current game
      if (data.gameCode !== this.game.gameCode) return false;

      // update game
      const gameCode = this.$route.params.gameCode;
      GameService.getGame(gameCode).then(async (game) => {
        this.game = game;

        // update player list
        this.getPlayers();

        // update admin name
        this.getAdminName();
      });
    },
    waitingMatchMessage: function (data) {
      // only when gameCode current game
      if (data.gameCode !== this.game.gameCode) return false;

      // if not same player
      if (data.player.id === this.player.id) return false;

      this.showMessage(data.message, data.state);
    },
    countDownStarts: function (data) {
      if (this.game.gameCode === data.gameCode) {
        this.countdown = 15;
        let interval = setInterval(() => {
          this.countdown--;
          if(this.countdown === 0){
            clearInterval(interval);
            this.$socket.emit("redirectToPlayingArea", {
              gameCode: this.game.gameCode,
            });
          }
        }, 1000);
      }
    },
    redirectToPlayingArea: function (data) {
      if (this.game.gameCode === data.gameCode) {
        this.$router.push(`/match/${data.gameCode}/playing`);
      }
    },
  },
  methods: {
    num00(a) {
      return ("0" + a).slice(-2);
    },
    showMessage(msg, state = "info", hide = 3) {
      this.message.msg = msg;
      this.message.state = state;
      this.message.show = true;

      clearTimeout(this.message.timeout);
      this.message.timeout = setTimeout(() => {
        this.hideMessage();
      }, hide * 1000);
    },
    hideMessage() {
      this.message.show = false;
    },
    async getPlayers() {
      let playerString = "";
      const players = await PlayerService.getPlayers();
      const playerIDs = this.game.playerIDs;

      for (let i = 0; i < playerIDs.length; i++) {
        let player = players.filter((p) => p.id === playerIDs[i])[0];

        playerString += player.username;

        playerString += player.ready
          ? '<span class="badge badge-success ml-1">ready</span>'
          : '<span class="badge badge-danger ml-1">not ready</span>';

        playerString += i + 1 === playerIDs.length ? "" : ", ";
      }

      this.ingamePlayers = playerString;
    },
    async getAdminName() {
      const admin = await PlayerService.getPlayer(this.game.playerIDs[0]);
      this.adminName = admin.username;
    },
    leaveGame() {
      // remove player from game
      GameService.removePlayer(this.game.gameCode, this.player.id);

      // delete player
      PlayerService.deletePlayer(this.player.id);
      this.$store.dispatch("setPlayer", null);

      // update socket view
      this.$socket.emit("playerLeaveGame", {
        gameCode: this.game.gameCode,
        player: this.player,
      });

      // message for other players
      this.$socket.emit("waitingMatchMessage", {
        gameCode: this.game.gameCode,
        player: this.player,
        message: `<b>${this.player.username}</b> left the game.`,
        state: "info",
      });

      // redirect to home
      this.$router.push({
        name: "start",
        params: {
          // error: 'Du hast das Spiel verlassen.'
        },
      });
    },
    async changeGameSetting() {
      // validate
      if (this.minPlayers < 2) {
        this.minPlayers = 2;
        return false;
      }

      // get game to avoid update error
      this.game = await GameService.getGame(this.game.gameCode);

      // set new vars
      this.game.minPlayers = parseInt(this.minPlayers);
      this.game.maxPlayers = parseInt(this.maxPlayers);
      this.game.fieldsize = parseInt(this.fieldsize);
      this.game.qnum = parseInt(this.qnum);
      this.game.public = this.public;
      this.game.hour = this.hour;
      this.game.minute = this.minute;
      this.game.second = this.second;
      this.game.seconds = parseInt(this.hour)*3600+parseInt(this.minute)*60+parseInt(this.second);

      // update game
      this.game = await GameService.updateGame(this.game);

      // update game for other players
      this.$socket.emit("updateGameVars", { gameCode: this.game.gameCode });
    },

    async readyPlayer() {
      // set ready state
      this.player.ready = true;

      this.player = await PlayerService.updatePlayer(this.player);
      this.$store.dispatch("setPlayer", this.player);

      // fetch game var new
      this.game = await GameService.getGame(this.game.gameCode);

      // start game when all players ready
      // TODO get ready players
      let readyPlayers = 0;

      for (let i = 0; i < this.game.playerIDs.length; i++) {
        let pl = await PlayerService.getPlayer(this.game.playerIDs[i]);
        if (pl.ready) readyPlayers++;
      }

// update game
      this.$socket.emit("updateGameVars", { gameCode: this.game.gameCode });

      //const playerIDs = this.game.playerIDs;
      // if all players ready and bigger than minplayers
      if (
        readyPlayers >= this.game.minPlayers &&
        readyPlayers === this.game.playerIDs.length
      ) {
        this.$socket.emit("countDownStarts", { gameCode: this.game.gameCode });
      }



      // message for other players
      this.$socket.emit("waitingMatchMessage", {
        gameCode: this.game.gameCode,
        player: this.player,
        message: `<b>${this.player.username}</b> is now ready.`,
        state: "success",
      });
    },

    async startGame() {
      this.$socket.emit("redirectToPlayingArea", {
        gameCode: this.game.gameCode,
      });
    }
  },
};
</script>

<style scoped>
.info-container{
  text-align: left;
}
.infoLabel {
  font-weight: bold;
  margin-right: 10px;
  display:inline-block;
  width:230px;
  text-align: left;
}
.infoRow{
  margin:10px;
}
h3{
  text-align: center;
}
</style>
